var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var template = "\n  <component\n    v-if=\"isComponent\"\n    :is=\"is\"\n    v-model=\"value[fieldName]\"\n    v-bind=\"vBind\"\n    v-on=\"vOn\"\n  >\n    <slot></slot>\n  </component>\n  <div v-else-if=\"fieldContent !== undefined && fieldContent !== null\" v-html=\"fieldContent\"></div>\n";
import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
var RenderSchema = /** @class */ (function (_super) {
    __extends(RenderSchema, _super);
    function RenderSchema() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RenderSchema.prototype, "fieldContent", {
        get: function () {
            var _a = this, value = _a.value, schema = _a.schema, field = _a.field, attrs = _a.attrs, listeners = _a.listeners;
            if (typeof schema === 'string') {
                var schemaObject = value.$schemaSet[schema];
                if (schemaObject) {
                    return schemaObject
                        .build(value, field)
                        .setAttrs(attrs)
                        .setListeners(listeners)
                        .get();
                }
                return null;
            }
            return schema
                .build(value, field)
                .setAttrs(attrs)
                .setListeners(listeners)
                .get();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderSchema.prototype, "isComponent", {
        get: function () {
            return typeof this.fieldContent === 'object';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderSchema.prototype, "is", {
        get: function () {
            if (this.isComponent) {
                var fieldContent = this.fieldContent;
                return fieldContent.is;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderSchema.prototype, "fieldName", {
        get: function () {
            if (this.isComponent) {
                var fieldContent = this.fieldContent;
                return fieldContent.name || this.field;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderSchema.prototype, "vBind", {
        get: function () {
            if (this.isComponent) {
                var fieldContent = this.fieldContent;
                return Object.assign({}, fieldContent.bind, this.attrs);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderSchema.prototype, "vOn", {
        get: function () {
            if (this.isComponent) {
                var fieldContent = this.fieldContent;
                return Object.assign({}, fieldContent.on, this.listeners);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderSchema.prototype, "attrs", {
        get: function () {
            return __assign({}, this.$attrs);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderSchema.prototype, "listeners", {
        get: function () {
            var listeners = __assign({}, this.$listeners);
            delete listeners.input;
            return listeners;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", Object)
    ], RenderSchema.prototype, "value", void 0);
    __decorate([
        Prop({ type: [String, Object], required: true }),
        __metadata("design:type", Object)
    ], RenderSchema.prototype, "schema", void 0);
    __decorate([
        Prop({ type: String, required: true }),
        __metadata("design:type", String)
    ], RenderSchema.prototype, "field", void 0);
    __decorate([
        Inject({ from: 'validator', default: null }),
        __metadata("design:type", Object)
    ], RenderSchema.prototype, "validator", void 0);
    RenderSchema = __decorate([
        Component({ template: template })
    ], RenderSchema);
    return RenderSchema;
}(Vue));
export { RenderSchema };
//# sourceMappingURL=RenderSchema.js.map